document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const sections = document.querySelectorAll('[data-beardo-hall-section]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-beardo-hall-track]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    const GAP = 12;
    const itemWidth = items[0].offsetWidth + GAP;
    const totalWidth = itemWidth * items.length;
    const duration = Math.max(20, totalWidth / 40);

    track.style.setProperty('--beardo-hall-scroll-duration', `${duration}s`);
  });
});
